import { solveInBrowser } from './dd-browser.js';
import { chooseCardSampled as choose, scoreCardsSampled as score, } from './play-sampled.js';
export { mcDecisionSeed } from './play-sampled.js';
export { disposeBrowserDdWorker } from './dd-browser.js';
/** Only sampled layouts, never the true hidden hands, reach the Web Worker. */
export function chooseCardSampled(deal, contract, plays, opts) {
    return choose(deal, contract, plays, opts, solveInBrowser);
}
export function scoreCardsSampled(deal, contract, plays, opts) {
    return score(deal, contract, plays, opts, solveInBrowser);
}
//# sourceMappingURL=play-mc-browser.js.map